import styled from 'styled-components';
import Grid from '../Utility/Grid';

export const StyledGridCol = styled(Grid.Col)`
  margin: 1rem 0;
`;
